import { Component } from '@angular/core';

@Component({
  selector: 'app-fix-how-we-can-help',
  templateUrl: './fix-how-we-can-help.component.html',
  styleUrl: './fix-how-we-can-help.component.scss'
})
export class FixHowWeCanHelpComponent {

}
